import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Users, Phone, MessageSquare } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { useNotificationCounts } from '@/hooks/useNotificationCounts';

const MobileBottomNav = () => {
  const location = useLocation();
  const counts = useNotificationCounts();
  
  const navItems = [
    {
      label: 'Contact',
      href: '/admin/all-leads',
      icon: Users,
      count: counts.contactLeads,
    },
    {
      label: 'Calls',
      href: '/admin/calls',
      icon: Phone,
      count: counts.phoneLeads,
    },
    {
      label: 'SMS',
      href: '/admin/sms-phone-numbers',
      icon: MessageSquare,
      count: counts.smsMessages,
    },
  ];

  // Don't show if not on admin routes or in conversation view
  if (!location.pathname.startsWith('/admin')) {
    return null;
  }

  // Hide in SMS conversation view to maximize chat space
  if (location.pathname.includes('/conversations/') && location.pathname.includes('/sms-phone-numbers/')) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-background border-t border-border md:hidden z-50 pb-[env(safe-area-inset-bottom)]">
      <div className="grid grid-cols-3 h-16">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.href || location.pathname.startsWith(item.href);
          
          return (
            <NavLink
              key={item.href}
              to={item.href}
              className={cn(
                "relative flex flex-col items-center justify-center gap-1 text-xs transition-colors min-h-[44px]",
                isActive 
                  ? "text-primary bg-primary/10" 
                  : "text-muted-foreground hover:text-foreground active:bg-muted"
              )}
            >
              <div className="relative">
                <Icon className="h-6 w-6" />
                {item.count > 0 && (
                  <Badge 
                    variant="destructive" 
                    className="absolute -top-2 -right-2 h-5 min-w-[1.25rem] flex items-center justify-center p-0 px-1 text-[10px]"
                  >
                    {item.count > 99 ? '99+' : item.count}
                  </Badge>
                )}
              </div>
              <span className="font-medium">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default MobileBottomNav;